/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/edicion";
        var params = {
            base: base,
            baseUrl: "/:relacionId/edicion",
            templateUrlBase: "app/admin/edicion/edicion",
            controller: 'EdicionAdminController',
            controllerForm: 'EdicionFormAdminController',
            translateBase: "admin.edicion.",
            parent: "admin/relacion"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            },
            resolve: {
                /* @ngInject */
                relacion: function ($stateParams, Relacion) {
                    console.log("!!!Cargando la relación!!!");
                    return Relacion.getNombreAndBdrs({id: $stateParams.relacionId}).$promise;
                }
            },
            ncyBreadcrumb: {
                parent: "admin/relacion/list"
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1'
            }
        });

        var resolve = {
            /* @ngInject */
            roles: function (EnumService) {
                return EnumService.get("rol-responsable");
            },
            /* @ngInject */
            tamanos: function (EnumService) {
                return EnumService.get("tamano");
            },
            /* @ngInject */
            portadas: function (EnumService) {
                return EnumService.get("portada");
            },
            /* @ngInject */
            tipoletras: function (EnumService) {
                return EnumService.get("tipoletra");
            },
            /* @ngInject */
            modalidaddiscursos: function (EnumService) {
                return EnumService.get("modalidaddiscurso");
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Edicion, $stateParams) {
                    var edicion = new Edicion();
                    edicion.relacion = {id: $stateParams.relacionId};
                    return edicion;
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Edicion, $stateParams) {
                    return Edicion.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
